



















































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  Action, State
} from 'vuex-class'
import { AppStatusState } from '@/types'

@Component({

})
export default class ErrorModal extends Vue {
  @State app!: AppStatusState
  @Action clearError!: Function

  get errorList () {
    if (this.app.data === null) {
      return []
    }
    if (typeof this.app.data !== 'object') {
      return []
    }
    return Object.keys(this.app.data).flatMap(key => this.app.data[key])
  }
}
